export const GET_PRODUCTS = 'GET_PRODUCTS';
export const PRODUCTS_ERROR = 'PRODUCTS_ERROR'